import * as React from 'react';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Menu, MenuItem, IconButton, ListItemIcon, Typography } from '@mui/material';

export default function ThreeDotMenu({ onAccept, onReject, onCustomer, onProduct, data }) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const onAcceptClick = () => {
    handleClose();
    onAccept(data);
  };
  const onRejectClick = () => {
    handleClose();
    onReject(data);
  };
  const onCustomerClick = () => {
    handleClose();
    onCustomer(data);
  };
  const onProductClick = () => {
    handleClose();
    onProduct(data);
  };

  return (
    <>
      <div>
        <IconButton
          id="basic-button"
          aria-controls={open ? 'basic-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
        >
          <MoreVertIcon />
        </IconButton>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
        >
          {onProduct && (
            <MenuItem onClick={onProductClick}>
              <Typography variant="inherit">Product Info</Typography>
            </MenuItem>
          )}
          {onCustomer && (
            <MenuItem onClick={onCustomerClick}>
              <Typography variant="inherit">Customer Info</Typography>
            </MenuItem>
          )}
          {onAccept && (
            <MenuItem onClick={onAcceptClick}>
              <Typography variant="inherit">Accept</Typography>
            </MenuItem>
          )}
          {onReject && (
            <MenuItem onClick={onRejectClick}>
              <Typography variant="inherit">Reject</Typography>
            </MenuItem>
          )}
        </Menu>
      </div>
    </>
  );
}
